import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Header from "../../components/Header";
import { FormattedMessage } from "react-intl";
import CertificateThirdPartyProductSelection from "../../components/Certificates/CertificateThirdPartyProductSelection";

function CertificatesCreateThirdParty({ history }) {
  return (
    <>
      <Header>
        <h1>
          <FormattedMessage id="certificates.title" defaultMessage="Certificates" />
        </h1>
      </Header>
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <CertificateThirdPartyProductSelection history={history}></CertificateThirdPartyProductSelection>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CertificatesCreateThirdParty;
